(() => {
  const updateVariantId = (modal) => {
    const modalContent = modal.querySelector('.quick-add-modal__content-wrapper');
    if (!modalContent) return;
    
    const form = modalContent.querySelector('form[action="/cart/add"]');
    const priceElement = modalContent.querySelector('.price');
    const productElement = modalContent.querySelector('.product');
    
    if (!form) return;
    
    const variantInput = form.querySelector('input[name="id"]');
    if (!variantInput) return;
    
    const update = () => {
      const variantId = variantInput.value;
      if (priceElement && variantId) priceElement.setAttribute('data-variant-id', variantId);
      if (productElement && variantId) productElement.setAttribute('data-variant-id', variantId);
    };
    
    update();
    
    new MutationObserver(update).observe(variantInput, {
      attributes: true,
      attributeFilter: ['value']
    });
    
    const variantSelects = modalContent.querySelector('variant-selects');
    if (variantSelects) {
      variantSelects.addEventListener('change', () => {
        update();
        if (window.Abra) window.Abra.render();
      });
    }
  };
  
  const observeModal = (modal) => {
    new MutationObserver(() => {
      if (modal.hasAttribute('open')) {
        if (window.Abra) window.Abra.render();
        setTimeout(() => updateVariantId(modal), 50);
      }
    }).observe(modal, {
      attributes: true,
      attributeFilter: ['open']
    });
    
    if (modal.hasAttribute('open')) {
      if (window.Abra) window.Abra.render();
      setTimeout(() => updateVariantId(modal), 50);
    }
  };
  
  document.querySelectorAll('quick-add-modal').forEach(observeModal);
  
  new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node.tagName === 'QUICK-ADD-MODAL') {
          observeModal(node);
        }
      });
    });
  }).observe(document.body, {
    childList: true,
    subtree: true
  });
})();